"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.validateRules = exports.RULE_VALIDATIONS = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _validator = _interopRequireDefault(require("validator"));

var _i18n = require("../../i18n");

var _utils = require("../../../utils");

var RULE_VALIDATIONS = {
  required: function required(_ref) {
    var value = _ref.value;
    return !(0, _utils.isEmpty)(value) || (0, _i18n.msg)({
      id: 'components.form.rules.required',
      defaultMessage: 'Required field!'
    });
  },
  min: function min(_ref2, _min) {
    var value = _ref2.value;
    return value && value.length >= _min || (0, _i18n.msg)({
      id: 'components.form.rules.min',
      defaultMessage: "Length field must be at least {min}"
    }, {
      min: _min
    });
  },
  max: function max(_ref3, _max) {
    var value = _ref3.value;
    return value && value.length <= _max || (0, _i18n.msg)({
      id: 'components.formalizer.rules.max',
      defaultMessage: "Length field must be at most {max}"
    }, {
      max: _max
    });
  },
  email: function email(_ref4) {
    var value = _ref4.value;
    return (0, _utils.isEmpty)(value) || _validator.default.isEmail(value) || (0, _i18n.msg)({
      id: 'components.form.rules.email',
      defaultMessage: 'Must be a valid email'
    });
  },
  alpha: function alpha(_ref5) {
    var value = _ref5.value;
    return (0, _utils.isEmpty)(value) || _validator.default.isAlpha(value) || (0, _i18n.msg)({
      id: 'components.form.rules.alpha',
      defaultMessage: 'Must contain only letters (a-zA-Z)'
    });
  },
  alphanumeric: function alphanumeric(_ref6) {
    var value = _ref6.value;
    return (0, _utils.isEmpty)(value) || _validator.default.isAlphanumeric(value) || (0, _i18n.msg)({
      id: 'components.form.rules.alphanumeric',
      defaultMessage: 'Only letters and numbers allowed'
    });
  },
  creditCard: function creditCard(_ref7) {
    var value = _ref7.value;
    return (0, _utils.isEmpty)(value) || _validator.default.isCreditCard(value) || (0, _i18n.msg)({
      id: 'components.form.rules.creditCard',
      defaultMessage: 'Must be a valid credit card'
    });
  },
  hexColor: function hexColor(_ref8) {
    var value = _ref8.value;
    return (0, _utils.isEmpty)(value) || _validator.default.isHexColor(value) || (0, _i18n.msg)({
      id: 'components.form.rules.hexColor',
      defaultMessage: 'Must be a hexadecimal color'
    });
  },
  integer: function integer(_ref9) {
    var value = _ref9.value;
    return (0, _utils.isEmpty)(value) || _validator.default.isInt(value) || (0, _i18n.msg)({
      id: 'components.form.rules.integer',
      defaultMessage: 'Must be an integer number'
    });
  },
  decimal: function decimal(_ref10) {
    var value = _ref10.value;
    return (0, _utils.isEmpty)(value) || _validator.default.isDecimal(value) || (0, _i18n.msg)({
      id: 'components.form.rules.decimal',
      defaultMessage: 'Must be a decimal number'
    });
  },
  float: function float(_ref11) {
    var value = _ref11.value;
    return (0, _utils.isEmpty)(value) || _validator.default.isFloat(value) || (0, _i18n.msg)({
      id: 'components.form.rules.float',
      defaultMessage: 'Must be a float number'
    });
  },
  domain: function domain(_ref12) {
    var value = _ref12.value;
    return (0, _utils.isEmpty)(value) || _validator.default.isFQDN(value) || (0, _i18n.msg)({
      id: 'components.form.rules.domain',
      defaultMessage: 'Must be a valid domain'
    });
  },
  url: function url(_ref13) {
    var value = _ref13.value;
    return (0, _utils.isEmpty)(value) || _validator.default.isURL(value) || (0, _i18n.msg)({
      id: 'components.form.rules.url',
      defaultMessage: 'Must be a valid URL'
    });
  }
};
exports.RULE_VALIDATIONS = RULE_VALIDATIONS;

var validateRules = /*#__PURE__*/function () {
  var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(instance, rules) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", rules.map(function (rule) {
              if (typeof rule === 'string') {
                var _rule$split = rule.split(':'),
                    ruleName = _rule$split[0],
                    ruleVar = _rule$split[1];

                if (RULE_VALIDATIONS[ruleName]) {
                  return RULE_VALIDATIONS[ruleName](instance, ruleVar);
                }
              }

              if (typeof rule === 'function') {
                return rule(instance);
              }

              return true;
            }).filter(function (validation) {
              return validation !== true;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validateRules(_x, _x2) {
    return _ref14.apply(this, arguments);
  };
}();

exports.validateRules = validateRules;